import React, { useEffect, useState } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Divider, Form, Input, message, Radio } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import { useHistory, useLocation } from 'react-router-dom'
import { ErrorMessages } from '../../helpers/textValidation'
import { createLocomotive, updateLocomotive } from '../../Services/LocomotiveServices'
import PageLayout from '../../Components/LayoutComponents/PageLayout'

const LocomotiveLookup = () => {
    const [edit, setEdit] = useState(false)
    const [form] = Form.useForm()
    const { state, data } = useLocation()
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState('');
    const history = useHistory()
    // All Field Items  
    const Fields = [
        {
            name: "Equipment Id",
            key: "EquipId",
            type: "Text",
            required: true,
        },
        {
            name: "Model",
            key: "locoModel",
            type: "Text",
            required: true
        },
        {
            name: "Horsepower",
            key: "locoHorsepower",
            type: "Number",
            required: true
        },
        {
            name: "Powered Axis",
            key: "poweredAxels",
            type: "Number",
            required: true
        },
        {
            name: "Type",
            key: "unitType",
            type: "Text",
            required: true
        },
        {
            name: "Customer/site",
            key: "customer_Site",
            type: "Text",
            required: true
        },
        {
            name: "Customer Contact",
            key: "customerContact",
            type: "Text",
            required: true
        },
        {
            name: "Customer Contact 1",
            key: "contactNum1",
            type: "Text",
            required: true
        },
        {
            name: "Customer Contact 2",
            key: "contactNum2",
            type: "Text",
            required: true
        },
        {
            name: "Contact Email",
            key: "contactEmail",
            type: "Text",
            required: true
        },
        {
            name: "FRA",
            key: "FRA",
            type: "Radio",
            required: true
        },
        {
            name: "Job Number",
            key: "jobNumber",
            type: "Number",
            required: true
        },
        {
            name: "Status",
            key: "status",
            type: "Text",
            required: true
        },
        {
            name: "Manufacturing Year",
            key: "MfrYear",
            type: "Number",
            required: true
        },
        {
            name: "Terp",
            key: "TERP",
            type: "Text",
            required: true
        },
        {
            name: "Lease / Own",
            key: "leaseOWN",
            type: "Text",
            required: true
        },
        {
            name: "starting TE",
            key: "startingTE",
            type: "Number",
            required: true
        }, {
            name: "locomotive Weight",
            key: "locoWeight",
            type: "Number",
            required: true
        }
    ]
    const onChange = (e) => {

        setValue(e.target.value);
    };

    useEffect(() => {
        if (state?.type === 'Create') setEdit(true)
        else {
            form.setFieldsValue({
                ...state?.data,
            })
        }
    }, [])

    const HandleSubmit = async (values) => {
        let data = {
            ...values,
            locoWeight: Number(values?.locoWeight),
            startingTE: Number(values?.startingTE),
            jobNumber: Number(values?.jobNumber),
            poweredAxels: Number(values?.poweredAxels),
            locoHorsepower: Number(values?.locoHorsepower),
        }
        if (state?.type === 'Create') {
            try {
                const result = await createLocomotive(data)
                if (result?.httpStatus === 200) {
                    message.success('Locomotive Created');
                    history.push({ pathname: "/Locomotivelisting" })
                    return
                }
            } catch (error) {

                message.error(error?.response?.data?.message)
            }


        } else {
            const result = await updateLocomotive(state?.data?.id, data)
            if (result?.httpStatus === 200) message.success("Locomotive Updated Successfully")

        }
    }

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <Grid id="PageTitle">Locomotive Lookup</Grid>
                {/* Render Children Component Here  */}
                <div style={{}}>
                    <Form style={{ marginTop: '30px', display: "flex", flexDirection: "column", gap: "20px" }}
                        name="LocomotiveForm"
                        onFinish={HandleSubmit}
                        form={form}
                    >
                        {
                            Fields.map((item, index) => (
                                <div style={{ display: "flex", alignItems: "center", gap: "200px", }}>
                                    <p style={{
                                        fontWeight: "800", whiteSpace: "nowrap",
                                        padding: "0px",
                                        margin: "0px", fontSize: "16px"
                                        , width: "100px"
                                    }}>{item.name}</p>
                                    <Form.Item name={item?.key} rules={[{ required: item?.required, message: ErrorMessages.requiredField }]} style={{ display: "flex", alignItems: "center", margin: "0px" }}>
                                        {
                                            item?.type === 'Radio' ?
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <Radio.Group onChange={onChange} value={value} name={item?.name}  >
                                                        <Radio value={"Yes"}>Yes</Radio>
                                                        <Radio value={"No"}>No</Radio>
                                                    </Radio.Group>
                                                </div>
                                                :
                                                <Input type={item?.type} placeholder='Enter value' readOnly={!edit} style={{
                                                    backgroundColor: edit ? 'white' : "#f6f6f6",
                                                    border: !edit && 'none',
                                                    fontSize: "16px",
                                                    width: "200px"
                                                }} />

                                        }
                                    </Form.Item>
                                </div>
                            ))
                        }
                        {/* Edit Button----------------> */}
                        <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
                            {
                                state?.type !== "Create" &&
                                <Button style={{
                                    backgroundColor: "#2963ad",
                                    color: "white",
                                    border: "none",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    padding: "0px 30px"
                                }} onClick={() => { setEdit(!edit) }}> {edit ? 'Cancel' : "Edit"}</Button>
                            }

                            <Button loading={loading} htmlType={state?.type === "Create" ? ' Submit' : edit ? "Submit" : ""} onClick={() => { state?.type !== "Create" && !edit && history.push('/Locomotivelisting') }} style={{
                                backgroundColor: state?.type !== "Create" ? "white" : "#2963ad",
                                border: "none",
                                color: state?.type !== "Create" ? "#2963ad" : "white",
                                fontWeight: "500",
                                fontSize: "18px",
                                padding: "0px 30px"
                            }}>   {state?.type === "Create" ? "Create Locomotive" : edit ? 'Save' : "Go back"}</Button>
                        </div>

                    </Form>



                </div>
            </Grid>
        </PageLayout>

    )
}

export default LocomotiveLookup